export { default } from './Newsletter';



// WEBPACK FOOTER //
// ./src/components/Newsletter/index.ts